var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddImageIcon, BLACK, Button, DeleteIcon, DynamicSvg, Loader, RED_600, StateConfigContext, Typography, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { useContext } from 'react';
import { Image, Pressable, View } from 'react-native';
import { getUploadSingleFileStyles, getUploadSingleFileUIProp } from './UploadSingleFileStyles';
export var UploadSingleFile = props => {
  var id = props.id,
    imgUrl = props.imgUrl,
    title = props.title,
    subTitle = props.subTitle,
    isLoading = props.isLoading,
    actionCtaText = props.actionCtaText,
    iconName = props.iconName,
    onActionCtaPress = props.onActionCtaPress,
    onUserAction = props.onUserAction,
    showDeleteIcon = props.showDeleteIcon,
    onDeleteIconPress = props.onDeleteIconPress,
    hintText = props.hintText,
    testID = props.testID,
    handleDeletePress = props.handleDeletePress,
    handleActionCtaPress = props.handleActionCtaPress,
    actionCtaIconName = props.actionCtaIconName,
    restProps = __rest(props, ["id", "imgUrl", "title", "subTitle", "isLoading", "actionCtaText", "iconName", "onActionCtaPress", "onUserAction", "showDeleteIcon", "onDeleteIconPress", "hintText", "testID", "handleDeletePress", "handleActionCtaPress", "actionCtaIconName"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var uploadSingleFileStyles = getUploadSingleFileStyles(props, isLargeScreen, theme);
  var uploadSingleFileUIProp = getUploadSingleFileUIProp(isLargeScreen, theme);
  return _jsxs(View, Object.assign({}, restProps, getTestId(testID), {
    children: [_jsxs(View, Object.assign({
      style: uploadSingleFileStyles.container
    }, {
      children: [_jsxs(View, Object.assign({
        style: [uploadSingleFileStyles.imageContainer, uploadSingleFileUIProp.uploadedImage]
      }, {
        children: [!imgUrl && !iconName && _jsx(View, Object.assign({
          style: uploadSingleFileStyles.addImageIcon
        }, {
          children: _jsx(AddImageIcon, Object.assign({}, uploadSingleFileUIProp.addImageIcon))
        })), !imgUrl && iconName && _jsx(View, Object.assign({
          style: uploadSingleFileStyles.addImageIcon
        }, {
          children: _jsx(DynamicSvg, Object.assign({
            iconName: iconName
          }, getTestId(testID, iconName)))
        })), !!imgUrl && _jsx(Image, {
          source: Object.assign({
            uri: imgUrl
          }, uploadSingleFileUIProp.uploadedImage),
          style: uploadSingleFileStyles.image
        })]
      })), _jsxs(View, Object.assign({
        style: uploadSingleFileStyles.textContainer
      }, {
        children: [!!title && _jsx(Typography, Object.assign({}, uploadSingleFileUIProp.title, {
          text: title
        })), !!subTitle && _jsx(Typography, Object.assign({}, uploadSingleFileUIProp.subTitle, {
          style: uploadSingleFileStyles.subTitle,
          text: subTitle
        }))]
      })), _jsxs(View, Object.assign({
        style: uploadSingleFileStyles.actionContainer
      }, {
        children: [!!isLoading && _jsx(Loader, {
          customSize: 24
        }), !!actionCtaText && _jsx(Button, Object.assign({}, uploadSingleFileUIProp.retryCta, {
          title: actionCtaText,
          iconName: actionCtaIconName,
          onPress: () => {
            handleActionCtaPress === null || handleActionCtaPress === void 0 ? void 0 : handleActionCtaPress(actionCtaText);
            onActionCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onActionCtaPress), {
              actionCtaText
            }));
          }
        })), !!showDeleteIcon && _jsx(Pressable, Object.assign({
          onPress: () => {
            handleDeletePress === null || handleDeletePress === void 0 ? void 0 : handleDeletePress(title);
            onDeleteIconPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onDeleteIconPress), {
              title
            }));
          }
        }, {
          children: _jsx(DeleteIcon, {
            fontSize: 24,
            color: BLACK
          })
        }))]
      }))]
    })), !!hintText && _jsx(Typography, {
      text: hintText,
      type: "body-para-xs",
      color: RED_600,
      style: uploadSingleFileStyles.hintText
    })]
  }));
};